module.exports = __webpack_public_path__ + "img/reflective-reader.b15c3fc0.png";